import { createColumnHelper } from "@tanstack/react-table";
import React, { useMemo } from "react";

export const useColumns = () => {
  const columnHelper = createColumnHelper();

  const columns = useMemo(
    () =>
      [
        columnHelper.accessor('skuReference', {
          header: () => 'SKU Reference',
          cell: (info) => (
            <strong>
              {info.getValue()}
            </strong>
          ),
          filterFn: 'includesString',
          meta: {
            priority: 1,
            style: { whiteSpace: 'nowrap' }
          }
        }), 
        columnHelper.accessor('skuDesc', {
          header: () => 'Description',
          filterFn: 'includesString',
          meta: { priority: 2},
        }),
        columnHelper.accessor('htsNumber', {
          header: () => 'HTC',
          filterFn: 'includesString',
          meta: { priority: 2},
        }),
        columnHelper.accessor('countryOfOrigin', {
          header: () => 'C/O',
          filterFn: 'includesString',
          meta: { priority: 3},
        }),
        columnHelper.accessor('pgaList', {
          header: () => 'PGA',
          filterFn: 'includesString',
          meta: { priority: 3},
        }),
        columnHelper.accessor('updatedDate', {
          header: () => 'Last Update Date',
          enableSorting: true,
          cell: (info) => {
            const date = info.getValue();
            return <span>{date ? new Date(date).toLocaleString() : '-'}</span>;
          },
        }),
      ].filter((column) => {
        return true;
      }),
    [columnHelper],
  );

  return columns
}